module.exports = __webpack_public_path__ + "static/logo2_m-97409f3cca3b59ed20c9bcaae29a2eaf.png";